import {
  FETCH_BALANCE_BY_WALLET,
  FETCH_BALANCE_BY_WALLET_SUCCESS,
  FETCH_BALANCE_BY_WALLET_FAILURE,
  RESET_BALANCE_BY_WALLET,
  FETCH_BALANCE_BY_GIFT_CARD,
  FETCH_BALANCE_BY_GIFT_CARD_SUCCESS,
  FETCH_BALANCE_BY_GIFT_CARD_FAILURE,
  RESET_BALANCE_BY_GIFT_CARD,
} from "./giftBalanceTypes";
export const fetchingState = {
  inProgress: "inProgress",
  success: "Success",
  failure: "Failure",
};
const initialState = {
  balanceByWallet: {
    fetchingStatus: {
      state: undefined,
    },
    balance: undefined,
    error: undefined,
  },
  balanceByGiftCard: {
    fetchingStatus: {
      state: undefined,
    },
    balance: undefined,
    error: undefined,
  },
};

const giftBalanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BALANCE_BY_WALLET:
      return {
        ...state,
        balanceByWallet: {
          ...state.balanceByWallet,
          fetchingStatus: {
            state: fetchingState.inProgress,
          },
        },
      };
    case FETCH_BALANCE_BY_WALLET_SUCCESS:
      return {
        ...state,
        balanceByWallet: {
          ...state.balanceByWallet,
          fetchingStatus: { state: fetchingState.success },
          balance: action.payload,
        },
      };
    case FETCH_BALANCE_BY_WALLET_FAILURE:
      return {
        ...state,
        balanceByWallet: {
          ...state.balanceByWallet,
          fetchingStatus: {
            state: fetchingState.failure,
          },
          balance: undefined,
          error: action.payload,
        },
      };
    case RESET_BALANCE_BY_WALLET: {
      return {
        ...state,
        balanceByWallet: {
          ...initialState.balanceByWallet,
        },
      };
    }
    case FETCH_BALANCE_BY_GIFT_CARD:
      return {
        ...state,
        balanceByGiftCard: {
          ...state.balanceByGiftCard,
          fetchingStatus: {
            state: fetchingState.inProgress,
          },
        },
      };
    case FETCH_BALANCE_BY_GIFT_CARD_SUCCESS:
      return {
        ...state,
        balanceByGiftCard: {
          ...state.balanceByGiftCard,
          fetchingStatus: { state: fetchingState.success },
          balance: action.payload,
        },
      };
    case FETCH_BALANCE_BY_GIFT_CARD_FAILURE:
      return {
        ...state,
        balanceByGiftCard: {
          ...state.balanceByGiftCard,
          fetchingStatus: {
            state: fetchingState.failure,
          },
          balance: undefined,
          error: action.payload,
        },
      };
    case RESET_BALANCE_BY_GIFT_CARD: {
      return {
        ...state,
        balanceByGiftCard: {
          ...initialState.balanceByGiftCard,
        },
      };
    }
    default:
      return {
        ...state,
      };
  }
};

export default giftBalanceReducer;
